var _g, _g2, _g3, _g4, _path, _g5, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGold = function SvgGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 154 154"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gold_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEB62",
    strokeWidth: 6,
    d: "M139 77c0 34.242-27.758 62-62 62-34.241 0-62-27.758-62-62S42.76 15 77 15s62 27.758 62 62Z",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gold_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 77,
    cy: 77,
    fill: "#FED803",
    rx: 39,
    ry: 40
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gold_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEB107",
    fillRule: "evenodd",
    d: "M77.002 51.304c-13.495 0-24.434 10.741-24.434 23.99 0 13.25 10.94 23.992 24.434 23.992s24.433-10.742 24.433-23.991c0-13.25-10.939-23.991-24.433-23.991m-29.697 23.99c0-16.103 13.296-29.157 29.697-29.157 16.4 0 29.696 13.054 29.696 29.158s-13.295 29.158-29.696 29.158-29.697-13.055-29.697-29.158",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gold_svg__d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.47,
    cy: 75.571,
    fill: "url(#gold_svg__e)",
    rx: 25.279,
    ry: 24.821
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gold_svg__f)",
    strokeWidth: 1.299,
    d: "M102.281 76.087c0-13.708-11.318-24.821-25.28-24.821"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gold_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gold_svg__h)",
    strokeWidth: 1.299,
    d: "M84.115 98.996c-13.507 3.469-27.321-4.47-30.854-17.733-.639-2.733-1.295-9.58 1.194-15.097"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FEF103",
    strokeLinecap: "round",
    strokeWidth: 7.147,
    d: "M44.326 84.684c1.557 5.324 4.446 10.096 8.29 13.945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gold_svg__i)",
    strokeLinecap: "round",
    strokeWidth: 5.848,
    d: "M90.902 45.188a33.6 33.6 0 0 1 11.996 9.212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gold_svg__j)",
    strokeLinecap: "round",
    strokeWidth: 1.299,
    d: "M51.154 91.152c1.103 1.813 2.498 3.428 3.457 4.417"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.944,
    cy: 91.153,
    fill: "#fff",
    rx: 2.388,
    ry: 2.345
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.09,
    cy: 98.628,
    fill: "#fff",
    rx: 1.479,
    ry: 1.453
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.996,
    cy: 40.589,
    fill: "#fff",
    rx: 1.479,
    ry: 1.453
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.375,
    cy: 63.16,
    fill: "#FFF871",
    rx: 1.479,
    ry: 1.453
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.571,
    cy: 103.771,
    fill: "#FFF76C",
    rx: 1.847,
    ry: 1.814
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.021,
    cy: 43.025,
    fill: "#FFF871",
    rx: 1.847,
    ry: 1.814
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F49200",
    stroke: "#F49200",
    strokeWidth: 0.334,
    d: "M70.564 66.047q-3.322-.045-4.582-.108a.676.676 0 0 0-.712.608q-.267 2.93-.318 9.496-.053 6.663-.302 9.751c-.026.323.185.636.528.684q.84.118 2.45.117 1.304 0 4.18-.111 2.262-.065 3.427-.079a.674.674 0 0 0 .66-.763l-.249-1.836a.635.635 0 0 0-.578-.557 19 19 0 0 0-1.32-.025q-.382 0-.847-.002a52 52 0 0 1-3.993-.189.336.336 0 0 1-.307-.333l-.001-.19a83 83 0 0 1 .003-2.054m1.96-14.41-.001.168m.002-.167-.002.167m.002-.167c2.442.032 4.144.101 5.097.207.276.03.493.235.557.497l.302 1.258a.653.653 0 0 1-.542.805q-1.422.195-4.558.446c-1.395.112-1.912.19-2.23.237-.079.012-.145.022-.21.03-.212.027-.378.198-.386.393-.011.286-.024.688.01 1.454.045.796.028 1.099.013 1.394-.005.091-.01.182-.013.287a.32.32 0 0 0 .287.319c.384.047.79.096 2.04.205 1.217.093 2.046.167 2.583.215l.126.01a.67.67 0 0 1 .6.538l.268 1.342a.67.67 0 0 1-.599.797c-2.817.248-4.202.357-4.977.4a.34.34 0 0 0-.326.341l.004.325c.009.754.02 1.726-.007 2.91m1.959-14.243q-3.322-.045-4.588-.108a.51.51 0 0 0-.537.456q-.267 2.917-.318 9.482-.053 6.666-.302 9.764a.46.46 0 0 0 .384.505q.821.114 2.428.115 1.297 0 4.173-.111zm-1.959 14.242v.001l-.167-.003.167.001zm16.19 5.509q2.455.055 3.7.055.766 0 2.058-.04a.667.667 0 0 0 .646-.667v-2.154a.647.647 0 0 0-.646-.654 46 46 0 0 0-.787.014c-.744.017-1.677.038-2.821-.006a31 31 0 0 0-2.371 0l-.35.01c-.228.005-.377-.234-.257-.451l7.657-13.941-.146-.08.146.757c.055-.776.083-.887.083-1V66.26a.67.67 0 0 0-.682-.669c-7.353.124-11.08.186-11.189.186h-.344c-.37 0-.669.299-.669.668v1.66c0 .346.268.645.626.651.345.007.707-.005 1.077-.016l.211-.006a18 18 0 0 1 1.38 0c.59.028 1.065.02 1.563.008l.065-.002c.48-.011.986-.023 1.647-.005.748.02 1.16.008 1.482-.002.235-.007.379.237.247.447-.299.478-.706 1.112-1.316 2.062l-1.146 1.786c-.889 1.386-1.815 2.59-2.678 3.71l-.021.027c-.853 1.107-1.646 2.136-2.267 3.171-1.228 2.06-1.697 3.604-1.757 4.154l-.001.01v1.119c0 .381.316.682.692.677.609-.008 1.365 0 1.94.007.284.004.523.006.68.006q1.124 0 3.549.056Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold_svg__e",
    x1: 71.106,
    x2: 69.235,
    y1: 100.393,
    y2: 50.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold_svg__f",
    x1: 72.961,
    x2: 103.518,
    y1: 51.266,
    y2: 76.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold_svg__h",
    x1: 83.456,
    x2: 54.969,
    y1: 98.78,
    y2: 64.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D25F05",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#D15E01",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D25F05",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold_svg__i",
    x1: 89.22,
    x2: 109.021,
    y1: 44.838,
    y2: 61.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold_svg__j",
    x1: 51.346,
    x2: 56.956,
    y1: 91.486,
    y2: 98.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gold_svg__a",
    width: 152.034,
    height: 152.034,
    x: 0.983,
    y: 0.983,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.84 0 0 0 0 0.876857 0 0 0 0 0.9 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3147_10957"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3147_10957",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gold_svg__b",
    width: 78,
    height: 80,
    x: 38,
    y: 37,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.548
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.882353 0 0 0 0 0.482353 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_3147_10957"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gold_svg__c",
    width: 59.393,
    height: 59.616,
    x: 47.305,
    y: 46.137,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.975
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.952941 0 0 0 0 0.560784 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_3147_10957"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gold_svg__d",
    width: 51.209,
    height: 50.94,
    x: 51.541,
    y: 50.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.65,
    dy: 1.299
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.975
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.989417 0 0 0 0 1 0 0 0 0 0.470833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_3147_10957"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gold_svg__g",
    width: 32.907,
    height: 35.212,
    x: 51.7,
    y: 65.57,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_3147_10957",
    stdDeviation: 0.162
  })))));
};
export default SvgGold;